import type {
  HeroLcpImageDimensions,
  HeroLcpSources
} from '@/lib/lcp/heroLcpAssets'

export const NEWS_PAGE_LCP_DIMENSIONS = {
  mobile: { width: 828, height: 473 },
  tablet: { width: 1200, height: 686 },
  desktop: { width: 1440, height: 823 }
} satisfies Record<keyof HeroLcpSources, HeroLcpImageDimensions>

export const NEWS_PAGE_LCP_SOURCES: HeroLcpSources = {
  mobile: '/assets/news-page-stadium-mobile.webp',
  tablet: '/assets/news-page-stadium-tablet.webp',
  desktop: '/assets/news-page-stadium.webp'
}

export const NEWS_PAGE_HERO_IMAGE_ALT = 'Stadium atmosphere background'
